<!--
//*TODO  

-->

<template>
    <div class="d-flex align-center flex-column justify-start fill-height" style="width: 100% !important;">
        <v-container fluid width=100% class="lightgrey pa-5">
            <v-card flat color="lightgrey" height=100%>
                <v-row class="pt-4 px-4">
                    <v-col cols="2" md="1" lg="1" class="d-flex align-center">
                        <v-row class="">
                            <div v-if="sensors.soil_temp >= 5 && sensors.soil_moisture >= 10 && period === 'OPEN'"> <v-icon size="40" color="success" position="center" class="pl-2">icons8-oil-tanker</v-icon> </div>
                            <div v-else-if="sensors.soil_temp < 5"> <v-icon size="40" color="error" position="center" class="pl-2">icons8-oil-tanker</v-icon> </div>
                            <div v-else-if="sensors.soil_moisture < 2"> <v-icon size="40" color="error" position="center" class="pl-2">icons8-oil-tanker</v-icon> </div>
                            <div v-else-if="period === 'CLOSED'"> <v-icon size="40" color="error" position="center" class="pl-2">icons8-oil-tanker</v-icon> </div>
                            <div v-else> <v-icon size="40" color="grey" position="center" class="pl-2">icons8-oil-tanker</v-icon> </div>
                        </v-row>
                    </v-col>
                    <v-col cols="10" class="d-flex align-center">
                        <div class="">
                            <div v-if="sensors.soil_temp >= 5 && sensors.soil_moisture >= 10"> <h3 class="font-weight-normal success--text">{{ $t('menu.slurry') }}</h3> </div>
                            <div v-else-if="sensors.soil_temp < 5"> <h3 class="font-weight-normal error--text">{{ $t('menu.slurry') }}</h3> </div>
                            <div v-else-if="sensors.soil_moisture < 2"> <h3 class="font-weight-normal error--text">{{ $t('menu.slurry') }}</h3> </div>
                            <div v-else-if="period === 'CLOSED'"> <h3 class="font-weight-normal error--text">{{ $t('menu.slurry') }}</h3> </div>
                            <div v-else> <h3 class="font-weight-normal">{{ $t('menu.slurry') }}</h3> </div>
                        <div class=""> <h5><span v-if="JSON.stringify(station) !== '{}'">{{ station.station_name }} </span></h5> </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-row class="pt-3" style="width: 100% !important;">    
            <v-col cols="12" xs="12" sm="6" md="5" lg="4">

                <dashcard :currentdata="currentData.slurryPeriod" :key="currentData.slurryPeriod.componentKey" />
                <dashcard :currentdata="currentData.soilTempDayDegC" :key="currentData.soilTempDayDegC.componentKey" />
                <dashcard :currentdata="currentData.soilMoistureBar" :key="currentData.soilMoistureBar.componentKey" />
                <forecast :currentdata="currentData.weatherForecast" :key="currentData.weatherForecast.componentKey" />

                <!-- <v-card flat color="appbackground" width=100% height="130" class="pt-4 pa-2"> 
                    <weatherforecast />
                </v-card>  -->
                <div v-if="sensors.soil_temp >= 5 && sensors.soil_moisture >= 2">
                    <v-btn block depressed large @click="MIX_logActivity('slurrySpreading', station, currentData), overlay = !overlay" color="success" class="mt-3">{{ $t('buttons.activity') }}</v-btn>
                </div>

                <v-btn block depressed large @click="MIX_go('/farming')" class="mt-3 lightgrey">{{ $t('buttons.back') }}</v-btn>

                <v-overlay :value="overlay">
                    <v-card color="appbackground" flat style="width: 75vw !important">
                        <overlay :currentdata="currentData" :key="currentData.componentKey" :showButton="true" />
                        <v-col cols=12 class="">
                            <v-btn block depressed large @click="overlay = false" class="lightgrey darktext--text">{{ $t('buttons.back') }}</v-btn>   
                        </v-col>             
                    </v-card>
                </v-overlay>

            </v-col>
        </v-row>
    </div> 
</template>

<script>

import moment from 'moment'
import { mapGetters } from 'vuex'; // Map Actions / Getters
export default {
    name: 'SlurrySpreading',
    data: () => ({
        items: ['Gelli Aur', 'Example 1', 'Example 2'],
        station: {},
        current: [],
        forecast: {},
        overlay: false,
        sensors: {
            soil_temp: '-',
            soil_moisture: '-',
            //create all of the sensor values
        },
        beforeEndOfOpenPeriod: '',
        soilMoistureBarMin: 10,
        currentData: {
            activity: {
                title: 'menu.slurry'
            },
            slurryPeriod: {
                title: 'weather.slurrySpreadingPeriod.title',
                subtitle: 'weather.slurrySpreadingPeriod.date',
                icon: 'icons8-calendar',
                value: '-',
                status: 'grey',
                componentKey: 0,
            },
            soilTempDayDegC: {
                title: 'weather.soilTemperature',
                unit: "°C",
                icon: 'icons8-temperature',
                value: '-',
                status: 'grey',
                componentKey: 1,
            },
            soilMoistureBar: {
                title: 'weather.soilMoisture',
                unit: "bar",
                icon: 'icons8-soil',
                value: '-',
                status: 'grey',
                componentKey: 2,
            },
            weatherForecast: {
                value: [],
                componentKey: 4
            }
        }
    }),
    computed: {
        ...mapGetters({
                GET_activeStation: 'GET_activeStation',
                GET_weatherDataStations: 'GET_weatherDataStations',
                GET_weatherDataStationById: 'GET_weatherDataStationById',
                GET_weatherDataCurrent: 'GET_weatherDataCurrent',
        }),
        period() { 
            return this.MIX_farmingPeriod("slurryPeriod")
        }
    },
    methods: {
        convertToCelcius: function (value) {
          if (!value) return ''
          return parseFloat(((5/9) * (parseFloat(value) - 32)).toFixed())
        },  
        getSensor: function(sensor_type) {
            return this.current.find(sensor => parseInt(sensor.sensor_type) === parseInt(sensor_type) )
        },
        updateSensors() {
            var t = this;    
            var soil_temp = parseFloat(t.getSensor(105).data[0].temp_last)
            t.sensors.soil_temp = t.convertToCelcius(soil_temp);
            t.sensors.soil_tempUpdated = t.getSensor(105).data[0].ts;
            t.sensors.soil_moisture = parseFloat(t.getSensor(108).data[0].moist_soil_last) 
            t.sensors.soil_moistureUpdated = t.getSensor(108).data[0].ts;
        },
        updateSlurryPeriod() {
            var t = this;
            t.currentData.slurryPeriod.value = t.period
            if (t.currentData.slurryPeriod.value === 'OPEN') {
                t.currentData.slurryPeriod.status = 'success';
                t.currentData.slurryPeriod.value = 'weather.slurrySpreadingPeriod.open'
            } else {
                t.currentData.slurryPeriod.status = 'error';
                t.currentData.slurryPeriod.value = 'weather.slurrySpreadingPeriod.closed'
            }
            t.currentData.slurryPeriod.componentKey++
        },
        updateSoilTempDayDegC() {
            var t = this;
            t.currentData.soilTempDayDegC.value = t.convertToCelcius(parseFloat(t.getSensor(105).data[0].temp_last))
            t.currentData.soilTempDayDegC.subtitle = t.MIX_formatDateTime(t.getSensor(105).data[0].ts, 'X', 'DD-MMM-YY HH:mm:ss')
            if (t.currentData.soilTempDayDegC.value >= 5) {
                t.currentData.soilTempDayDegC.status = 'success'
            } else {
                t.currentData.soilTempDayDegC.status = 'error'
            }
            t.currentData.soilTempDayDegC.componentKey++
        },
        updateSoilMoistureBar() {
            var t = this;
            t.currentData.soilMoistureBar.value = parseFloat(t.getSensor(108).data[0].moist_soil_last);
            t.currentData.soilMoistureBar.subtitle = t.MIX_formatDateTime(t.getSensor(108).data[0].ts, 'X', 'DD-MMM-YY HH:mm:ss')
           if (t.currentData.soilMoistureBar.value >= t.soilMoistureBarMin) {
                t.currentData.soilMoistureBar.status = 'success' 
            } else if (t.currentData.soilMoistureBar.value < 10 && t.currentData.soilMoistureBar.value <= 4) {
                t.currentData.soilMoistureBar.status = 'error'
            } else {
                t.currentData.soilMoistureBar.status = 'warning'
            }
            t.currentData.soilMoistureBar.componentKey++
        },
        updateForecast: async function(lat, lon) {
            var t = this;
            var forecastResult = await t.MIX_weatherDataForecast(lat, lon)
            t.currentData.weatherForecast.value = forecastResult.data.daily
            t.currentData.weatherForecast.componentKey++
        },
        checkDate() {      
            this.date = moment(new Date()).format('MM-DD')
            this.beforeEndOfOpenPeriod = moment(this.date).isBefore('10.14');
            return this.beforeEndOfOpenPeriod;
        }
    },
    async mounted () {
        var t = this;
        var routerPath = t.$route.path.split('/')
        var stationId = routerPath[2];
        t.station = await t.GET_weatherDataStationById(stationId);
        await t.MIX_weatherDataCurrent(stationId) 
        t.current = await t.GET_weatherDataCurrent;
        t.updateSensors();
        t.updateSlurryPeriod();
        t.updateSoilMoistureBar();
        t.updateSoilTempDayDegC();
        t.updateForecast(t.station.latitude, t.station.longitude);

    }
  }
</script>